import React, { forwardRef } from 'react';
import moment from 'moment';
import EditTimesTooltip from 'modules/fleet/edit-times-tooltip';

const t = {
  pending_appointment: 'Pending appointment',
};

const formatTimesWithDiff = (timeFrom, timeTo, firstStopTimeFrom) => {
  const momentFrom = moment(timeFrom);
  const momentTo = moment(timeTo);

  const firstTimeMoment = moment(firstStopTimeFrom).startOf('day');
  const stopTimeMoment = moment(timeFrom).startOf('day');
  const diff = moment.duration(stopTimeMoment.diff(firstTimeMoment)).asDays();

  const formatted =
    momentFrom.isSame(momentTo, 'hour') && momentFrom.isSame(momentTo, 'minute')
      ? moment(timeFrom).format('HH:mm')
      : `${moment(timeFrom).format('HH:mm')} - ${moment(timeTo).format('HH:mm')}`;

  const date = momentFrom.format('DD MMM');

  return {
    date,
    formatted,
    diff,
  };
};

const StopCell = forwardRef(
  (
    {
      label,
      timeFrom,
      timeTo,
      firstStopTimeFrom,
      showTimes = true,
      isPendingAppointment = false,
      allowEditTimes = false,
      showDate = false,
      onEditTimes,
      ...props
    },
    ref
  ) => {
    const hasFirstStopToCompare = !!firstStopTimeFrom;

    if (!timeFrom || !timeTo) {
      return null;
    }

    const { date, formatted, diff } = formatTimesWithDiff(timeFrom, timeTo, firstStopTimeFrom);

    return (
      <div className="cell cell__stop" data-testid="stopCell" {...props} ref={ref}>
        <EditTimesTooltip
          enabled={allowEditTimes}
          timeFrom={timeFrom}
          timeTo={timeTo}
          onSave={onEditTimes}
        >
          <div className="stop__nowrap">{label}</div>
          {showTimes && (
            <div className="stop__time">
              <span>
                {showDate && <span className="stop__date">{date}</span>}
                <strong>{formatted}</strong>
              </span>
              {!!(hasFirstStopToCompare && diff) && (
                <span className="stop__diff">+{Math.round(diff)} d</span>
              )}
            </div>
          )}
        </EditTimesTooltip>
        {isPendingAppointment && (
          <div className="cell__pending-appointment">{t.pending_appointment}</div>
        )}
      </div>
    );
  }
);

export default StopCell;
